import AnalyticsFilterInputs from "../../types/analytics/AnalyticsFilterInputs";
import {
  UsageLeagueDimension,
  UsageLeagueDto,
} from "../../types/analytics/UsageLeagueDto";

const BASE = "analytics/usage/league";

export type UsageLeagueResponse =
  | { status: "OK"; league: UsageLeagueDto }
  | { status: "UNAVAILABLE" };

class usageLeagueApi {
  constructor(private accessToken: string | undefined) {}

  async getLeague(
    filters: AnalyticsFilterInputs,
    dimension: UsageLeagueDimension,
    parentLocationId?: number,
  ): Promise<UsageLeagueResponse> {
    try {
      const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/${BASE}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify({
            filters,
            dimension,
            parentLocationId: parentLocationId ?? null,
          }),
        },
      );

      if (!response.ok) return { status: "UNAVAILABLE" };

      const league = (await response.json()) as UsageLeagueDto;
      return league?.rows
        ? { status: "OK", league }
        : { status: "UNAVAILABLE" };
    } catch {
      return { status: "UNAVAILABLE" };
    }
  }
}

export default usageLeagueApi;
